import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useAuth } from '../hooks/useAuth';
import { useSelector } from 'react-redux';
import { useUser } from '../hooks/useUser';

function PrivateRoute({ children, role, ...rest }) {
  let { isLoggedIn } = useAuth();
  const isLoadingUser = useSelector((state) => state.user.isLoadingUser);
  const { hasRole } = useUser();

  return (
    <Route
      {...rest}
      render={({ location }) => {
        if (!isLoggedIn && !isLoadingUser) {
          return (
            <Redirect
              to={{
                pathname: '/login',
                search:
                  '?next=' +
                  encodeURIComponent(location.pathname + location.search),
                state: { from: location },
              }}
            />
          );
        }
        if (role && !hasRole(role)) {
          return <Redirect to={{ pathname: '/' }} />;
        }
        return children;
      }}
    />
  );
}

PrivateRoute.propTypes = {
  children: PropTypes.node,
  role: PropTypes.any,
};

export default PrivateRoute;
